export default __webpack_public_path__ + "static/TrustAlice Illustrations--03-b4fc87ca5950dc2e1ec25e2dc4e54ef1.svg";